// extracted by mini-css-extract-plugin
export var dropdown = "_s9-0";
export var imageWrapper = "_s9-3";
export var itemNameContainer = "_s9-1";
export var productImage = "_s9-2";
export var spinnerWrapper = "_s9-4";